import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=58c4b292"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"
import style0 from "./ModalInsert.vue?vue&type=style&index=0&id=58c4b292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports